// extracted by mini-css-extract-plugin
export default {"headerTitle":"header-title--SVioe5i0XmeN9TwvzPt0"};